import { useMotionValue } from "motion/react";
import { productSigils } from "../data/productSigils";
import { DockIcon } from "./DockIcon";
import { Search, Command } from "lucide-react";

export function ProductDock({ onOpenPalette }: { onOpenPalette?: () => void }) {
  const mouseX = useMotionValue(Infinity);

  return (
    <div className="fixed top-0 left-0 right-0 z-50 h-28 px-4 md:px-8 pointer-events-none flex justify-center items-start pt-4">

      {/* Single Dock Pill — icons + divider + search */}
      <div
        onMouseMove={(e) => mouseX.set(e.pageX)}
        onMouseLeave={() => mouseX.set(Infinity)}
        className="pointer-events-auto flex items-end h-[80px] gap-2 sm:gap-3 px-4 sm:px-5 pb-3 rounded-[2rem] bg-[var(--p-gray-900)]/60 border border-white/10 backdrop-blur-2xl shadow-[0_32px_64px_-16px_#00000080]"
      >
        {/* Product icons */}
        {productSigils.map((product) => (
          <DockIcon key={product.id} mouseX={mouseX} product={product} />
        ))}

        {/* Vertical divider */}
        <div className="w-px h-8 bg-white/10 self-center mx-1 sm:mx-2 shrink-0" />

        {/* Search trigger */}
        <button
          onClick={onOpenPalette}
          onMouseEnter={() => mouseX.set(Infinity)}
          className="flex items-center gap-2 px-3 py-2 rounded-xl self-center transition-all hover:bg-white/5 active:scale-95 shrink-0"
        >
          <Search size={15} className="text-muted-foreground" />
          <kbd className="px-1.5 py-0.5 rounded exp-caption bg-white/5 text-muted-foreground font-mono border border-white/5 hidden sm:inline-flex items-center gap-0.5">
            <Command size={9} className="inline" />K
          </kbd>
        </button>
      </div>

    </div>
  );
}
